export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7882.1aed9afe.jpg";